<template>
  <div v-if="client">
    <h5>
      <span class="text-info ma-0 pa-0">ID Пользователя</span> {{ client.id }}
    </h5>
    <h5>
      <span class="text-info ma-0 pa-0">Статус</span>
      {{ client.client_status.body }}
    </h5>
    <div>
      <button
        v-if="timer <= 0"
        class="btn btn-success mw mt-2 mb-3"
        @click="refresh(60)"
      >
        Обновить данные
      </button>
      <h5 v-else class="mb-4">Ожидайте {{ timer }} секунд</h5>
    </div>
    <!-- CREATED -->
    <div v-if="client.client_status_key == 'CREATED'">
      <client-detail
        :id="order['client']['id']"
        v-model="order.client"
        :fieldList="fieldList"
      />

      <div class="border mt-3" v-if="order.client.passport_prefix">
        <table class="table">
          <tr
            v-for="(requirement, key) in requirements"
            :key="key"
            v-show="passportType[order.client.passport_prefix][requirement.key]"
          >
            <td>
              <p>
                <span class="text-info text-uppercase">
                  <span v-if="requirementTitle[requirement.key]">
                    {{ requirementTitle[requirement.key].title }}
                  </span>
                  <span v-else>{{ requirement.key }}}</span>
                </span>
                <span
                  :class="`${
                    requirement.value === true
                      ? 'ti-plus ml-2 text-success'
                      : 'ti-minus ml-2 text-danger'
                  }`"
                ></span>
              </p>
              <p class="text-gray">
                <!-- {{ requirement.required ? "Обязательно" : "Необязательно" }} -->
                <label>Обязательно</label>
              </p>
            </td>
            <td align="right">
              <button
                v-if="requirement.value === false || 1"
                class="btn btn-sm btn-danger"
                @click="selectModel(requirement.key)"
              >
                Выполнить
              </button>
            </td>
          </tr>
        </table>
      </div>

      <modal name="editor" v-if="model.name" width="400">
        <card>
          <button
            @click="$modal.hide('editor')"
            class="btn btn-close-card mb-3"
          >
            <span class="ti-arrow-left"></span>
          </button>
          <component
            :is="`_${model.name}`"
            :createTransaction="createTransaction"
            v-model="client"
            :updateOrder="updateOrder"
            :partner="partner"
            :transaction="transaction"
            :order="order"
            @update="refresh(0)"
          />
        </card>
      </modal>

      <button class="btn btn-info mw mt-2" @click="verifyClinet">
        Отправить на проверку
      </button>
    </div>
    <!-- IDENTIFIED-->
    <div
      v-else-if="
        client.client_status_key == 'IDENTIFIED' ||
        client.client_status_key == 'reviewed'
      "
    >
      <button class="btn btn-info mw" @click="buy">Продолжить покупку</button>
    </div>
    <!-- ANOTHER-->
    <div v-else>
      <h4>Ожидание ответа системы</h4>
    </div>
  </div>
</template>
<script>
import ClientDetail from "@/components/Partners/ClientDetail";
import { logger, errorNotify } from "../../../plugins/functions";
export default {
  components: {
    ClientDetail,
    _passport_face: () =>
      import("@/components/Partners/alif/Client/_PASSPORT_FACE"),
    _passport_address: () =>
      import("@/components/Partners/alif/Client/_PASSPORT_ADDRESS"),
    _passport_photo: () =>
      import("@/components/Partners/alif/Client/_PASSPORT_PHOTO"),
    _id_passport_face: () =>
      import("@/components/Partners/alif/Client/_ID_PASSPORT_FACE"),
    _id_passport_front: () =>
      import("@/components/Partners/alif/Client/_ID_PASSPORT_FRONT"),
    _id_passport_back: () =>
      import("@/components/Partners/alif/Client/_ID_PASSPORT_BACK"),
    _passport_entity: () =>
      import("@/components/Partners/alif/Client/_PASSPORT_ENTITY"),
    _card: () => import("@/components/Partners/alif/Client/_CARD"),
    _phones: () => import("@/components/Partners/alif/Client/_PHONES"),
    _questionnaire: () =>
      import("@/components/Partners/alif/Client/_QUESTIONNAIRE"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  async created() {
    this.refresh(0);
  },

  mounted() {
    setInterval(() => {
      this.timer--;
    }, 1000);
  },

  data() {
    return {
      timer: 0,
      requirementTitle: {
        passport_face: {
          title: "Селфи с паспортом",
        },
        passport_address: {
          title: "Фото прописки",
        },
        passport_photo: {
          title: "Фото паспорта",
        },
        id_passport_face: {
          title: "Селфи с ID",
        },
        id_passport_front: {
          title: "Фото ID",
        },
        id_passport_back: {
          title: "Фото задней части ID",
        },
        passport_entity: {
          title: "Информация паспорта",
        },
        card: {
          title: "Пластиковые карты",
        },
        phones: {
          title: "Доверители",
        },
        questionnaire: {
          title: "Деятельность",
        },
      },

      passportType: {
        id: {
          id_passport_front: true,
          id_passport_back: true,
          id_passport_face: true,

          passport_entity: true,
          card: true,
          phones: true,
          questionnaire: true,
        },
        old: {
          passport_photo: true,
          passport_address: true,
          passport_face: true,
          passport_entity: true,
          card: true,
          phones: true,
          questionnaire: true,
        },
      },
      fieldList: [
        {
          col: " col-12 col-md-12",
          key: "passport_prefix",
          labelKey: "passport_prefix",
          label: "Тип паспорта",
          type: "static_radio",
          items: [
            { id: "id", title: "ID" },
            { id: "old", title: "Обычный паспорт" },
          ],
        },
      ],
      model: {
        fieldList: [],
        name: "",
      },
      client: null,
      requirements: [],
    };
  },
  methods: {
    async refresh(timer = 0) {
      this.timer = timer;
      this.$loading(true);
      await this.getClient();
      await this.getRequirements();
      this.$loading(false);
      this.$modal.hide("editor");
    },

    async getRequirements() {
      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.requirements = await this.$http
        .get(
          `${partner["endpoint_url"]}clients/clients/${this.value["id"]}/requirements`,
          {
            params: {},
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
              locale: this.$store.state.language_current,
            },
          }
        )
        .then((response) => {
          return response.data.requirements;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          return null;
        })
        .finally(() => {});
    },

    async getClient() {
      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.client = await this.$http
        .get(`${partner["endpoint_url"]}clients/clients/${this.value["id"]}`, {
          params: {},
          headers: {
            Authorization: `Bearer ${partner["api_secret_key"]}`,
            "Content-Type": "application/json",
            Accept: "application/json",
            locale: this.$store.state.language_current,
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          return null;
        })
        .finally(() => {});
    },

    async verifyClinet() {
      this.$loading(true);
      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER
      this.$http
        .post(
          `${partner["endpoint_url"]}clients/clients/${this.client.id}/request-review`,
          {},
          {
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
              locale: this.$store.state.language_current,
            },
          }
        )
        .then((response) => {
          this.client = response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async selectModel(model) {
      this.model["name"] = model;

      setTimeout(() => {
        this.$modal.show("editor");
      }, 10);
    },
    async buy() {
      await this.createTransaction({
        step: "order-add",
      });

      this.$emit("setStep", "order-add");
    },
  },
};
</script>